const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:9304/api';

// 获取存储的 token
const getToken = () => localStorage.getItem('token');

// 通用请求方法
const request = async (url, options = {}) => {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  const response = await fetch(`${API_BASE}${url}`, {
    ...options,
    headers,
  });

  const data = await response.json();

  if (data.code !== 200) {
    throw new Error(data.message || '请求失败');
  }

  return data.data;
};

// 认证相关 API
export const authApi = {
  register: (data) => request('/auth/register', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  login: (data) => request('/auth/login', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  getCurrentUser: () => request('/auth/me'),

  sendVerificationCode: (email) => request(`/auth/send-code?email=${email}`),
};

// 帖子相关 API
export const postApi = {
  getList: (page = 1, size = 10) =>
    request(`/posts?page=${page}&size=${size}`),

  getById: (id) => request(`/posts/${id}`),

  getRanking: (limit = 10) => request(`/posts/ranking?limit=${limit}`),

  getMyPosts: (page = 1, size = 10) =>
    request(`/posts/my?page=${page}&size=${size}`),

  create: (data) => request('/posts', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  addReaction: (postId, reactionType) => request('/posts/reaction', {
    method: 'POST',
    body: JSON.stringify({ postId, reactionType }),
  }),

  delete: (id) => request(`/posts/${id}`, { method: 'DELETE' }),
};

// 标签相关 API
export const tagApi = {
  getPreset: () => request('/tags/preset'),
  getHot: (limit = 10) => request(`/tags/hot?limit=${limit}`),
};
